var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ModalContent', {
    attrs: {
      "stitch": ""
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v(_vm._s(_vm.$translate("title")))];
      },
      proxy: true
    }, {
      key: "content",
      fn: function fn() {
        return [_c('p', {
          staticClass: "font-weight-bold mb-2 text-h3"
        }, [_vm._v(" " + _vm._s(_vm.$translate("subtitle")) + " ")]), _c('p', {
          staticClass: "mb-2"
        }, [_vm._v(" " + _vm._s(_vm.$translate("intro")) + " ")]), _c('p', {
          staticClass: "mb-4"
        }, [_vm._v(" " + _vm._s(_vm.$translate("instruction")) + " ")]), _c('v-btn', {
          staticClass: "my-2",
          attrs: {
            "loading": _vm.isSending,
            "disabled": _vm.isSending,
            "color": "primary"
          },
          on: {
            "click": _vm.resendConfirmationEmail
          }
        }, [_vm._v(" " + _vm._s(_vm.$translate("resend")) + " ")]), _vm.successMessage ? _c('p', {
          staticClass: "text-success mt-2"
        }, [_c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "color": "success"
          }
        }, [_vm._v("mdi-check")]), _vm._v(" " + _vm._s(_vm.successMessage) + " ")], 1) : _vm._e(), _vm.errorMessage ? _c('p', {
          staticClass: "text-error mt-2"
        }, [_c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "color": "error"
          }
        }, [_vm._v("mdi-alert")]), _vm._v(" " + _vm._s(_vm.errorMessage) + " ")], 1) : _vm._e(), _c('p', {
          staticClass: "mt-4 text-muted"
        }, [_vm._v(" " + _vm._s(_vm.$translate("contactHelp")) + " "), _c('a', {
          attrs: {
            "href": "mailto:contact@safetee.io"
          }
        }, [_vm._v("contact@safetee.io")]), _vm._v(". ")])];
      },
      proxy: true
    }, {
      key: "bottom",
      fn: function fn() {
        return [_c('v-btn', {
          staticClass: "my-2 my-sm-4 w-100 w-sm-auto",
          on: {
            "click": _vm.hideModal
          }
        }, [_vm._v(" " + _vm._s(_vm.$translate("close")) + " ")])];
      },
      proxy: true
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }